import React from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import Researches from './Researches'
import ResearchesStore from '../../stores/researches'
import { formatDateTime, formatCurrency } from '../../utils/format'
import config from '../../config'
import moment from 'moment'


const getDiff = (start, finish) => {
  const diff = moment(finish).diff(moment(start))
  return moment(diff).utc().format('HH:mm:ss')
}

const itemsTime = (items = []) => {
  return items.map(({ createdAt, finishedAt, costs, ...other}) => {
    return {
      ...other,
      createdAt: formatDateTime(createdAt),
      finishedAt: other.status !== 'done' ? '' : formatDateTime(finishedAt),
      cost: `${config.NUMBER_CURRENCY_SYMBOL}${((costs || {}).total || 0).toFixed(4)}`,
      diff: other.status !== 'done' ? null : getDiff(createdAt, finishedAt)
    }
  })
}

@withRouter
@observer
class _Researches extends React.Component {
  constructor(props) {
    super(props)
    this.store = new ResearchesStore()
  }

  onChangeSort = orderByNew => e => {
    const { listProps } = this.store
    const { order, orderBy } = listProps
    let orderNew = ''
    if (orderBy === orderByNew) {
      if (order === 'desc') {
        orderNew = 'asc'
      } else {
        orderNew = 'desc'
      }
    } else {
      orderNew = 'desc'
    }

    this.store.onChangeSort(orderNew, orderByNew)
  }

  onChangePage = (e, page) => this.store.onChangePage(page)

  onChangeRowsPerPage = ({ target: { value }}) => this.store.onChangeRowsPerPage(value)

  onChangeFilters = name => object => {
    let value = null
    if (object.hasOwnProperty('target')) {
      value = object.target.value
    } else {
      value = object
    }
    this.store.onChangeFilter(name, value)
  }

  onClickRow = (e, id) => {
    if (e.ctrlKey || e.metaKey) {
      window.open(`/researches/${id}`, '_blank')
    } else {
      this.props.history.push(`/researches/${id}`)
    }
  }

  render () {
    const {
      listProps
    } = this.store

    const {
      items
    } = listProps

    return <Researches
      {...this.props}
      {...listProps}
      items={itemsTime(items)}
      onChangeSort={this.onChangeSort}
      onChangeFilters={this.onChangeFilters}
      onChangePage={this.onChangePage}
      onChangeRowsPerPage={this.onChangeRowsPerPage}
      onClickRow={this.onClickRow}
    />
  }
}

export default _Researches
